import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "var(--_dn-icon_color)",
  viewBox: "-6 -6 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 5.955C0 2.667 2.687 0 6 0s6 2.667 6 5.955v5.086h-.002v.32c0 .351-.36.639-.8.639h-2c-.44 0-.8-.287-.8-.639V7.758c0-.352.36-.64.8-.64H11V5.956C11 3.226 8.768 1 6 1S1 3.226 1 5.955V7.12h1.8c.44 0 .8.287.8.639v3.603c0 .351-.36.639-.8.639h-2c-.44 0-.8-.287-.8-.639z" }, null, -1)
  ]))]))
}
export default { render: render }